import React, { useState, useEffect } from "react";
import Countdown from "react-countdown-now";
import { withRouter, Link } from "react-router-dom";
import { BallBeat } from "react-pure-loaders";
import cookie from "react-cookies";
import { getToken, checkCode, recoverPassword, getCustomerByMail } from "../../services/api";
import Button from "../common/Button";
import { useLocation } from "../../hooks/location";
import svgCancel from "../../assets/svg/cancel.svg";

const idProduct = 4;

const PasswordRecoveryEmailConfirmation = (props) => {
  const [eMail, setEMail] = useState(null);
  const [counter, setCounter] = useState(false);
  const [codigo, setCodigo] = useState(null);
  const [codeError, setCodeError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { location, ip } = useLocation();

  useEffect(() => {
    let getEmail = sessionStorage.getItem("recoveryEmail");
    if (!getEmail) return props.history.push("/login");
    setEMail(getEmail);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("loggedUser") && cookie.load("token")) props.history.push("/dashboard/initial");
  }, []);

  const renderer = ({ seconds, completed }) => {
    if (completed) {
      // Render a completed state
      setCounter(true);
      return null;
    } else {
      // Render a countdown
      return <span className="text-gray-text">INTENTA DE NUEVO ({seconds} SEC.)</span>;
    }
  };

  const handleCode = async () => {
    if (!codigo) return setCodeError(true);
    if (codigo.length > 4) return setCodeError(true);
    setCodeError(false);
    setLoading(true);
    let data = {
      code: parseInt(codigo),
      idProduct,
      isNIP: false,
      userAgent: navigator.userAgent,
      clientIP: ip,
      coordinates: location,
    };
    let response = await getToken();
    if (!response) return;
    let validToken = response.data.token;
    getCustomerByMail(idProduct, eMail, validToken).then((res) => {
      if (res.status === 200) {
        data.idCustomer = res.data.customerId;
        localStorage.recoverIdCustomer = res.data.customerId;
        checkCode(data, validToken)
          .then((res) => {
            if (res.data.idStatus === 1) {
              sessionStorage.setItem("code-valid", "true");
              return props.history.push("/nuevo-password-confirmar");
            }
            setCodeError(true);
            setLoading(false);
          })
          .catch((err) => {
            setCodeError(true);
            setLoading(false);
          });
      }
    });
  };

  const sendAgain = async () => {
    let response = await getToken();
    if (!response) return;
    let validToken = response.data.token;
    const data = {
      idProduct,
      eMail,
    };
    recoverPassword(data, validToken);
  };

  return (
    <div className="bg-white relative w-full flex justify-center items-start flex-1">
      <div className="container flex flex-col gap-4 p-4 ">
        <div className="flex flex-col gap-4 py-4 max-w-4xl self-start">
          <div className="w-full flex flex-col gap-2">
            <h1 className="text-3xl font-extra-bold text-black-primary">Correo enviado</h1>
            <p>
              Hemos enviado un link para que puedas recuperar tu acceso a tu email <strong className="font-bold">{eMail}</strong>.
            </p>
          </div>

          <div className="w-full flex flex-col gap-4 rounded-lg bg-[#f0f0f0] p-4">
            <div className={`flex flex-col gap-2 w-full 2xl:w-2/3`}>
              <label className="font-bold">Código para recuperación </label>
              <input className={`w-full  ${codeError ? "border-red" : ""}`} type="text" name="codigo" maxLength="4" placeholder="Código para recuperación" value={codigo} onChange={(e) => setCodigo(e.target.value)} />
              {codeError ? <span className="text-red ">Código incorrecto</span> : null}
            </div>
            <Button className="self-start" onClick={handleCode}>
              {loading ? <BallBeat color={"#fff"} loading /> : "CONFIRMAR"}
            </Button>
            {counter ? (
              <p
                className="text-blue-primary hover:text-blue-light active:text-blue-dark cursor-pointer transition-all"
                onClick={() => {
                  sendAgain();
                  setCounter(false);
                }}
              >
                Enviar código nuevamente
              </p>
            ) : (
              <div>
                <Countdown date={Date.now() + 60000} renderer={renderer} />
                <br />
                <span className="text-gray-text">(Antes de reenviarte revisa tu carpeta de SPAM)</span>
              </div>
            )}
            <Link className="text-blue-primary hover:text-blue-light active:text-blue-dark font-bold transition-all" to="/recupera-opcion">
              Cambia opción de recuperación
            </Link>
            <div className="flex gap-2 cursor-pointer">
              <img src={svgCancel} width={20} alt="cancel" />
              <Link className="text-red font-bold transition-all" to="/login">
                Cancelar
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(PasswordRecoveryEmailConfirmation);
